import { render, staticRenderFns } from "./ListCmp.vue?vue&type=template&id=5ffd4d07&scoped=true"
import script from "./ListCmp.vue?vue&type=script&lang=js"
export * from "./ListCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd4d07",
  null
  
)

export default component.exports